import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import Apps from './App';

import { Provider } from "react-redux";
import { store, persistor } from "./context/store";
import { PersistGate } from 'redux-persist/integration/react'
import "typeface-roboto"; 
import './index.css'

function Router() {
   
  return(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Apps />
      </PersistGate>
    </Provider>
  )

}



ReactDOM.render(
  <React.StrictMode>
      <Router />
  </React.StrictMode>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
